import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  RideButton,
  RideGrid,
  RideGlQuestionOutline,
} from "@rimac-seguros/ride-system-components";

import { Image } from "@/components/atoms/Image";
import { useVisibilityElement } from "@/hooks/useVisibilityElement";
import Validation from "@/utils/validations";

import "./styles.scss";
import { VE_ROUTES_ENDORSEMENT } from "@/utils/consts";
import { ModalQuestionList } from "@/components/molecules/ModalQuestionList/index";
import { QUESTION_MODEL } from "@/features/Comprar/vida-endosable/step-plans/models/model";
import { getProductOptions, getScreenName } from "@/utils/product";
import helpers from "@/utils/helpers";
import { BannerCampaign } from "../BannerCampaign";

const logo = (
  <Image
    pngSrc="/ventadigital/devolucion/assets/rebrand/logo-rimac.svg"
    alt="Logo Rimac"
  />
);

export const NewHeader = ({
  product,
  productUniversity,
  classNameContent,
  className = "",
  backGround = "bg-ride-sys-color-background-default",
  isBordered = false,
  useLogoAsLink = false,
}) => {
  const { digitalDataProductName } = getProductOptions();
  const [isScrolled, setIsScrolled] = useState(false);
  const [openQuestion, setOpenQuestion] = useState(false);

  const pathname = window.location.pathname;
  const isStepInitial =
    pathname === "/comprar/seguro-vida-devolucion-garantizada";
  const { isVisible: isVisibleHero } = useVisibilityElement({
    targetId: isStepInitial ? "hero-section" : "",
    initialVisible: true,
  });
  const isEndorsementRoute = VE_ROUTES_ENDORSEMENT.some((route) =>
    pathname.includes(route.path)
  );

  const { experimentCyber } = useSelector((state) => state.experiment);
  const { dynamicContent } = useSelector((state) => state.dynamicContent);

  const universityVersion = Validation.validateUniversityInsurance();

  useEffect(() => {

    if (typeof window === "undefined") return;
    
    const setHeaderMargin = () => {
      const banner =
        document.querySelector(".banner-promotional") ||
        document.querySelector(".banner-cyberI");
      const header = document.getElementById("container-new-header");
      if (banner && header) {
        const bannerHeight = banner?.offsetHeight || 0;
        header.style.marginTop = `${bannerHeight}px`;
      } else if (header) {
        header.style.marginTop = "";
      }
    };

    setHeaderMargin();

    const observer = new MutationObserver(() => setHeaderMargin());

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      observer.disconnect();
    };
  }, []);

  const handleClickQuote = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleQuestion = () => {
    const screenName = getScreenName();

    helpers.setActionTag({
      group: digitalDataProductName,
      category: screenName,
      action: "click",
      label: "Dudas frecuentes",
    });
    setOpenQuestion(true);
  };

  return (
    <>
      {
        isStepInitial &&
        <BannerCampaign
          dynamicContent={dynamicContent}
          valueEntry={
            process.env.REACT_APP_ID_ENTRY_UPDATE_DATA_CONTENTSTACK_VCD || ""
          }
        />
      }
      <header
        id="container-new-header"
        className={`container-new-header ${
          experimentCyber?.isActive && isStepInitial ? "" : "sticky top-0"
        } ${classNameContent || ""} ${backGround || ""} ${
          isScrolled && isStepInitial && !isVisibleHero
            ? "shadow-ride-gl-shadow-moderate"
            : ""
        } ${isBordered ? "border-b-ride-gl-border-width-thin" : ""}`}
      >
        <RideGrid className="w-full">
          <div
            className={`container-new-header_content ${
              isStepInitial && !isVisibleHero ? "is-step-initial" : ""
            } ${className}`}
          >
            <div
              className={`container-new-header_left ${
                isEndorsementRoute ? "w-full" : ""
              }`}
            >
              {useLogoAsLink ? (
                <a
                  href="https://www.rimac.com"
                  className="container-new-header_left-img"
                  aria-label="Logo Rimac"
                >
                  {logo}
                </a>
              ) : (
                <div className="container-new-header_left-img">{logo}</div>
              )}
              <div className="container-new-header_left-text">
                <h1>{universityVersion ? productUniversity : product}</h1>
                {isEndorsementRoute && (
                  <span>
                    <RideButton
                      text="¿Tienes dudas?"
                      variant="text-primary"
                      size="medium"
                      glyph={<RideGlQuestionOutline />}
                      glyphPosition="right"
                      className="w-full"
                      onClick={handleQuestion}
                    />
                  </span>
                )}
              </div>
            </div>
            <div className="container-new-header_right">
              {isStepInitial && !isVisibleHero && (
                <RideButton
                  text="Cotizar ahora"
                  size="x-large"
                  onClick={handleClickQuote}
                />
              )}
            </div>
          </div>
        </RideGrid>
      </header>
      <ModalQuestionList
        {...QUESTION_MODEL}
        isOpen={openQuestion}
        setIsOpen={setOpenQuestion}
      />
    </>
  );
};
